// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const chewtle: PokeData = {
  "id": 833,
  "name": "chewtle",
  "height": 3,
  "weight": 85,
  "base_experience": 57,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "body-slam",
    "bite",
    "water-gun",
    "counter",
    "protect",
    "liquidation",
    "jaw-lock"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "body-slam",
    "bite",
    "protect",
    "liquidation",
    "aqua-cutter",
    "aqua-jet",
    "water-spout",
    "hydro-pump",
    "bubble-beam",
    "aqua-tail",
    "brine"
  ],
  "evolution_chain": {
    "id": 439,
    "item": null,
    "species": [
      {
        "name": "chewtle",
        "order": 833,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "drednaw",
        "order": 834,
        "types": [
          PokeType.WATER,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 833,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 47,
    "speed": 44,
    "ability_power": 64
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
